import PropTypes from 'prop-types';
import { getLowerCaseSelector } from 'utils/clickme';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

const PayerType = ({ payerType }) => {
    const trl = useTrls();

    const lowerCasePayerType = getLowerCaseSelector(payerType);
    return (
        <Label type={`payer-${lowerCasePayerType}`}>
            {trl(`admin.Invoices.InvoicesTable.Invoice.payerType.${lowerCasePayerType}`)}
        </Label>
    );
};

PayerType.propTypes = {
    payerType: PropTypes.string,
};

export default PayerType;
